module.exports = __webpack_public_path__ + "teqbahn-assets/media/21.d140d9cc.png";